"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Self-adjusting timer to account for drifting
 * orig: https://stackoverflow.com/questions/29971898/how-to-create-an-accurate-timer-in-javascript
 *
 * @param {function} callback  Callback containing the work to be done for each interval
 * @param {int}      interval  Interval speed (in milliseconds) - This
 * @param {bool} shouldFireImmediately (Optional) Flag to indicate if the function should be
 *                                                run immediately.
 */
var SelfAdjustingTimer = function SelfAdjustingTimer(callback, interval) {
  var _this = this;

  _classCallCheck(this, SelfAdjustingTimer);

  this.start = function () {
    _this.expected = Date.now() + _this.interval;
    _this.timeout = setTimeout(_this.step, _this.interval);
  };

  this.stop = function () {
    clearTimeout(_this.timeout);
    _this.timeout = 0;
  };

  this.step = function () {
    var drift = Date.now() - _this.expected;
    _this.callbackFn();
    _this.expected += _this.interval;
    _this.timeout = setTimeout(_this.step, Math.max(0, _this.interval - drift));
  };

  this.expected = undefined;
  this.timeout = undefined;
  this.interval = interval;
  this.callbackFn = callback;
};

exports.default = SelfAdjustingTimer;